import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { DICT } from "./dictionary";

const LangCtx = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("sns_lang") || "es");

  useEffect(() => {
    localStorage.setItem("sns_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const setLang = useCallback((l) => {
    if (l === "es" || l === "en") setLangState(l);
  }, []);

  // t(key, fallback?, params?) — admite sustitución tipo {var}
  const t = useCallback((key, fallback, params) => {
    let actualFallback = fallback;
    let actualParams = params;
    // Permite t(key, params) cuando fallback es un objeto
    if (typeof fallback === "object" && fallback !== null && !Array.isArray(fallback)) {
      actualParams = fallback;
      actualFallback = undefined;
    }
    let str = DICT[lang]?.[key] ?? actualFallback ?? key;
    if (actualParams && typeof str === "string") {
      str = str.replace(/\{(\w+)\}/g, (_, k) =>
        actualParams[k] !== undefined ? String(actualParams[k]) : `{${k}}`
      );
    }
    return str;
  }, [lang]);

  return (
    <LangCtx.Provider value={{ lang, setLang, t }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
